import { Box } from "@mui/material";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import classNames from "classnames";

interface CircularProgressBarProps {
  className?: string;
  color?:
    | "error"
    | "inherit"
    | "secondary"
    | "primary"
    | "info"
    | "success"
    | "warning";
  progress: number;
}

export const CircularProgressBar = ({
  progress,
  color = "error",
  className,
}: CircularProgressBarProps) => {
  const classes = classNames("CircularProgressBar", className);
  return (
    <Box sx={{ position: "relative" }} className={classes}>
      <CircularProgress
        variant="determinate"
        color="secondary"
        sx={{
          color: (theme) => theme.palette.grey[300],
        }}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        color={color}
        sx={{
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        value={progress}
      />
    </Box>
  );
};
